import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import apiClient from '@/apiClient'
import type { EntitlementsResponse } from '@/types/backend'

export const useEntitlementsQuery = (enabled = true) =>
  useQuery({
    queryKey: ['entitlements'],
    enabled,
    queryFn: async () => {
      const { data } = await apiClient.get<EntitlementsResponse>(
        '/owners/me/entitlements'
      )
      return data
    },
    staleTime: 30_000,
  })

export const useStartTrialMutation = () => {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async (payload: {
      days?: number
      channel?: 'EMAIL' | 'WHATSAPP'
    }) => {
      const { data } = await apiClient.post(
        '/subscriptions/trial/start',
        payload ?? {}
      )
      return data
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['owner'] })
      qc.invalidateQueries({ queryKey: ['entitlements'] })
    },
  })
}
